import { useState, useEffect } from 'react';
import { useEquipo } from '../context/EquipoContext';
import { useAuth }   from '../context/AuthContext';

export default function Estadisticas() {
  const { equipo } = useEquipo();
  const { user }   = useAuth();

  const [parejas,         setParejas]         = useState([]);
  const [cargandoParejas, setCargandoParejas] = useState(false);
  const [tabActivo,       setTabActivo]       = useState('general');

  const esFutbol = !equipo?.deporte || equipo?.deporte === 'futbol';

  useEffect(() => {
    if (!esFutbol && user?.id) {
      setCargandoParejas(true);
      fetch(`${process.env.REACT_APP_API_URL}/api/parejas/jugador/${user.id}`)
        .then(r => r.json())
        .then(data => { if (Array.isArray(data)) setParejas(data); })
        .catch(() => {})
        .finally(() => setCargandoParejas(false));
    }
  }, [user, esFutbol]);

  const parejasFiltradas = parejas.filter(p => p.deporte === equipo?.deporte);

  const winRatePorPareja = (p) => {
    const partidos = p.partidos || 0;
    if (partidos === 0) return 0;
    return Math.round((p.victorias / partidos) * 100);
  };

  const campoElo = esFutbol ? 'elo' : equipo?.deporte === 'padel' ? 'elo_padel' : 'elo_tenis';
  const eloActual = equipo?.[campoElo] || equipo?.elo || 1000;

  return (
    <div style={styles.pagina}>
      <div style={styles.header}>
        <div style={styles.titulo}>Estadísticas</div>
        <div style={styles.sub}>Métricas y rendimiento de tu equipo</div>
      </div>

      {/* Stats generales */}
      <div style={styles.statsGrid}>
        {[
          { n: eloActual,            l: 'ELO actual',       color: '#1A6BFF' },
          { n: equipo?.partidos || 0, l: 'Partidos jugados', color: '#141922' },
          { n: equipo?.victorias|| 0, l: 'Victorias',        color: '#16A34A' },
          { n: equipo?.partidos
              ? `${Math.round((equipo.victorias / equipo.partidos) * 100)}%`
              : '0%',               l: '% victorias',       color: '#FF6B1A' },
        ].map(({ n, l, color }) => (
          <div key={l} style={styles.statCard}>
            <div style={{ ...styles.statNum, color }}>{n}</div>
            <div style={styles.statLabel}>{l}</div>
          </div>
        ))}
      </div>

      {/* Tabs para padel/tenis */}
      {!esFutbol && (
        <>
          <div style={styles.tabs}>
            <button
              onClick={() => setTabActivo('general')}
              style={{ ...styles.tab, background: tabActivo === 'general' ? '#FF6B1A' : 'white', color: tabActivo === 'general' ? 'white' : '#6B7280', border: `1.5px solid ${tabActivo === 'general' ? '#FF6B1A' : '#E8ECF4'}` }}
            >
              Individual
            </button>
            <button
              onClick={() => setTabActivo('parejas')}
              style={{ ...styles.tab, background: tabActivo === 'parejas' ? '#FF6B1A' : 'white', color: tabActivo === 'parejas' ? 'white' : '#6B7280', border: `1.5px solid ${tabActivo === 'parejas' ? '#FF6B1A' : '#E8ECF4'}` }}
            >
              Mis Parejas
            </button>
          </div>

          {tabActivo === 'parejas' && (
            <div style={styles.parejasSection}>
              <div style={styles.sectionTitulo}>
                Rendimiento por pareja — {equipo?.deporte === 'padel' ? 'Pádel' : 'Tenis'}
              </div>
              <div style={styles.sectionSub}>
                Descubre con quién tienes mejor rendimiento en dobles.
              </div>

              {cargandoParejas ? (
                <div style={styles.cargando}>Cargando parejas...</div>
              ) : parejasFiltradas.length === 0 ? (
                <div style={styles.vacio}>
                  <div style={{ fontSize: 32, marginBottom: 8 }}>🤝</div>
                  <div style={styles.vacioTitulo}>Sin historial de dobles aún</div>
                  <div style={styles.vacioSub}>
                    Cuando juegues partidos de dobles, aquí verás tu rendimiento con cada compañero.
                  </div>
                </div>
              ) : (
                <div style={styles.parejasList}>
                  {parejasFiltradas
                    .sort((a, b) => (b.elo || 1000) - (a.elo || 1000))
                    .map((p, i) => {
                      const compañero = p.jugador1_id === user?.id ? p.jugador2_nombre : p.jugador1_nombre;
                      const winRate   = winRatePorPareja(p);
                      const derrotas  = (p.partidos || 0) - (p.victorias || 0) - (p.empates || 0);
                      return (
                        <div key={p.id} style={styles.parejaCard}>
                          <div style={styles.parejaRank}>#{i + 1}</div>
                          <div style={styles.parejaCrest}>
                            {compañero?.split(' ').map(x => x[0]).slice(0,2).join('') || '??'}
                          </div>
                          <div style={styles.parejaInfo}>
                            <div style={styles.parejaNombre}>Con {compañero}</div>
                            <div style={styles.parejaStats}>
                              <span style={{ color: '#16A34A' }}>{p.victorias || 0}V</span>
                              {' · '}
                              <span style={{ color: '#EF4444' }}>{derrotas}D</span>
                              {' · '}
                              <span style={{ color: '#9BA5B7' }}>{p.partidos || 0} partidos</span>
                            </div>
                          </div>
                          <div style={styles.parejaEloWrap}>
                            <div style={styles.parejaElo}>{p.elo || 1000}</div>
                            <div style={styles.parejaEloLabel}>ELO</div>
                            <div style={{ ...styles.parejaWinRate, color: winRate >= 50 ? '#16A34A' : '#EF4444' }}>
                              {winRate}% vic.
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          )}
        </>
      )}

      {(esFutbol || tabActivo === 'general') && (
        <div style={styles.proximamente}>
          <div style={styles.proximamenteSub}>
            Historial completo y gráficos de rendimiento disponibles
            cuando hayas jugado partidos en TuRival.
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  pagina: { padding: '24px 32px' },
  header: { marginBottom: 24 },
  titulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 32, fontWeight: 800, color: '#141922', marginBottom: 4 },
  sub: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 24, maxWidth: 700 },
  statCard: { background: 'white', border: '1px solid #E8ECF4', borderRadius: 14, padding: '16px', textAlign: 'center' },
  statNum: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 32, fontWeight: 800, lineHeight: 1, marginBottom: 6 },
  statLabel: { fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' },
  tabs: { display: 'flex', gap: 8, marginBottom: 20 },
  tab: { padding: '9px 18px', borderRadius: 20, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 700, transition: 'all 0.12s' },
  parejasSection: { maxWidth: 600 },
  sectionTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 18, fontWeight: 800, color: '#141922', marginBottom: 4 },
  sectionSub: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", marginBottom: 16 },
  cargando: { textAlign: 'center', padding: '40px', fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  vacio: { textAlign: 'center', padding: '40px 20px' },
  vacioTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 18, fontWeight: 800, color: '#141922', marginBottom: 8 },
  vacioSub: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", lineHeight: 1.6 },
  parejasList: { display: 'flex', flexDirection: 'column', gap: 10 },
  parejaCard: { display: 'flex', alignItems: 'center', gap: 12, background: 'white', border: '1px solid #E8ECF4', borderRadius: 14, padding: '14px 16px' },
  parejaRank: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: '#9BA5B7', width: 28, textAlign: 'center' },
  parejaCrest: { width: 40, height: 40, borderRadius: 10, background: '#0D1117', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 800, color: 'white', flexShrink: 0 },
  parejaInfo: { flex: 1 },
  parejaNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700, color: '#141922', marginBottom: 3 },
  parejaStats: { fontSize: 12, fontFamily: "'Barlow', sans-serif" },
  parejaEloWrap: { textAlign: 'right' },
  parejaElo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800, color: '#141922', lineHeight: 1 },
  parejaEloLabel: { fontSize: 10, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  parejaWinRate: { fontSize: 12, fontWeight: 700, fontFamily: "'Barlow Condensed', sans-serif", marginTop: 2 },
  proximamente: { maxWidth: 500 },
  proximamenteSub: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", lineHeight: 1.6, fontStyle: 'italic' },
};
